import React, { memo } from 'react'

const IconCountry = ({ color = "black", ...props }) => (
    <svg {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M17.25 9C17.25 13.5563 13.5563 17.25 9 17.25M17.25 9C17.25 4.44365 13.5563 0.75 9 0.75M17.25 9H0.75M9 17.25C4.44365 17.25 0.75 13.5563 0.75 9M9 17.25C10.7949 17.25 12.25 13.5563 12.25 9C12.25 4.44365 10.7949 0.75 9 0.75M9 17.25C7.20507 17.25 5.75 13.5563 5.75 9C5.75 4.44365 7.20507 0.75 9 0.75M0.75 9C0.75 4.44365 4.44365 0.75 9 0.75" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
    </svg>
);

export default memo(IconCountry)